import { useSelector } from 'react-redux';

import { IRootState } from '@app/store';
import { FilterType } from '@reducers/referral/ReferralReducer';

const useNotificationChecker = () => {
  const { unreadCount: referralUnreadCount, filter: referralFilter } = useSelector(
    (state: IRootState) => state.Referral,
  );
  const labOrderUnreadCount = useSelector(
    (state: IRootState) => state.LabOrder.unreadCount,
  );

  const hasNotification = (navKey: string): boolean => {
    switch (navKey) {
      case '/referrals': {
        if (!referralUnreadCount || !referralFilter) return false;
        const countForFilter = referralUnreadCount[referralFilter as FilterType];
        return countForFilter?.all > 0;
      }
      case '/lab-orders': {
        return Object.values(labOrderUnreadCount || {}).some(
          (count) => typeof count === 'number' && count > 0,
        );
      }
      default:
        return false;
    }
  };

  return hasNotification;
};

export default useNotificationChecker;
